import React from "react";

import classnames from "classnames";

import { Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: "transparent",
  },
  legend: {
    display: "block",
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontWeight: 600,
    letterSpacing: "0.1em",
  },
}));

// react-admin's layouts hand the record to their direct children only —
// SimpleShowLayout clones them, SimpleForm sends them through FormInput. A
// section that stands between the layout and the fields has to pass that on
// itself, or every field inside it renders blank.
const INJECTED_PROPS = [
  "record",
  "basePath",
  "resource",
  "variant",
  "margin",
  "version",
];

/**
 * A titled fieldset for grouping read-only fields or inputs inside a
 * SimpleForm/SimpleShowLayout — the flat-layout counterpart of a form tab.
 */
export const FormSection = ({ title, className, children, ...props }) => {
  const classes = useStyles();
  const injected = INJECTED_PROPS.reduce((acc, key) => {
    if (props[key] !== undefined) acc[key] = props[key];
    return acc;
  }, {});

  return (
    <Paper variant="outlined" className={classnames(classes.root, className)}>
      {title && (
        <Typography
          variant="overline"
          color="textSecondary"
          className={classes.legend}
        >
          {title}
        </Typography>
      )}
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, injected)
          : child,
      )}
    </Paper>
  );
};

// FormInput stamps a fixed width on any form child that does not declare
// fullWidth, which would pinch a whole section down to an input's width.
FormSection.defaultProps = {
  fullWidth: true,
};
